// Tenant-controlled "Require OTP verification" for past orders and
// loyalty (Oct 2026).
//
// The one place the storefront and the tenant editor interpret the
// setting. Only an exact `false` means "OTP not required"; a missing,
// null or malformed value means "required" — the same fail-closed rule
// the server applies (`backend/retail/loyalty_access_policy.py::
// otp_required`). In the storefront this is a DISPLAY decision only:
// the server re-reads the stored setting on every lookup and refuses a
// no-OTP request whenever OTP is required.

export const REQUIRE_OTP_LABEL = "Require OTP verification";

export const REQUIRE_OTP_HELPER_TEXT =
  "When enabled, customers must verify their phone number with a one-time passcode before viewing eligible past orders or using loyalty points. When disabled, customers can continue using their phone number without an OTP. A confirmation text is sent whenever points are redeemed.";

export const OTP_SECURITY_NOTICE =
  "Security notice: When OTP verification is disabled, anyone who knows a customer’s phone number may be able to view eligible past orders and use that customer’s loyalty points. Rudras-AI will send the customer a confirmation text whenever points are used, but this notification does not prevent unauthorized use. By disabling OTP, your business accepts this risk.";

// Product Owner decision (2 Oct 2026) — loyalty balances are tenant-wide.
export const SHARED_BALANCE_NOTICE =
  "Loyalty balances are shared across your business. Disabling OTP for this catalog allows phone-only access to the customer’s business-wide loyalty balance through this catalog.";

// Shown while the mandatory redemption-confirmation path is not ready
// (backend `services/loyalty_no_otp_readiness.py`).
export const NO_OTP_NOT_READY_EXPLANATION =
  "Phone-only lookup can’t be turned on until the mandatory points-redemption confirmation text is ready.";

export const OTP_RISK_ACKNOWLEDGEMENT =
  "I understand and accept the risks of allowing loyalty access without OTP verification.";

/** Tenant editor: the stored admin catalog document. */
export function catalogRequiresOtp(catalog) {
  return catalog?.require_otp_verification !== false;
}

/** Storefront: the public catalog payload (`loyalty_otp_required`). */
export function storefrontRequiresLoyaltyOtp(catalog) {
  return catalog?.loyalty_otp_required !== false;
}

/** Acknowledgement is needed only for the required → not-required move. */
export function needsRiskAcknowledgement(savedRequired, nextRequired) {
  return savedRequired === true && nextRequired === false;
}
